import React from 'react';

import classes from './TrdResult.css';

const trdResult = (props) => {

   
    let resultClass = [classes.TrdResult]

    if ( props.highlight ){
        resultClass.push(classes.Highlight)
    }

    // let other = null

    // if ( props.other ) {
    //    other = <p>Email List: {props.other}</p>
    // }


    return (
        <div className={resultClass.join(' ')}>
            <div className={classes.Index}>
                <p>{props.index + 1}.</p>
            </div>
            <div className={classes.RegName}>
                <p>{props.name}</p>
            </div>
            <div className={classes.Paypal}>
                <p>PayPal: {props.paypal}</p>
                {/* {other} */}
            </div>
        </div>
    )
}

export default trdResult;


// WEBPACK FOOTER //
// ./src/components/UI/TrdAdminFocus/TrdResult/TrdResult.js